import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CloudIcon from "@mui/icons-material/Cloud";
import SecurityIcon from "@mui/icons-material/Security";
import TerminalIcon from "@mui/icons-material/Terminal";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import "../assets/styles/Main.scss";
import stef from "../assets/images/profil.png";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../hooks/usePageTitle";
import { Link } from "react-router-dom";

const domains = [
  {
    icon: <CloudIcon fontSize="inherit" />,
    label: "Cloud & Infrastructure",
    techs: [ "GCP", "Azure","Cloudflare","Proxmox", "Linux","M365"],
  },
  {
    icon: <SecurityIcon fontSize="inherit" />,
    label: "Sécurité & Réseaux",
    techs: ["Fortinet", "Stormshield", "SentinelOne", "IAM","VPN","Bastion"],
  },
  {
    icon: <TerminalIcon fontSize="inherit" />,
    label: "DevOps & Automatisation",
    techs: ["Kubernetes", "Helm", "Docker", "Terraform", "GitLab CI"],
  },
  {
    icon: <MonitorHeartIcon fontSize="inherit" />,
    label: "Monitoring & Alerting",
    techs: ["Prometheus", "Grafana", "Alert Manager","Zabbix","Uptime"],
  },
];

const Main = () => {
  const { t } = useTranslation();
  usePageTitle('Accueil');

  return (
    <div className="container">
      <section className="about-section">
        <div className="hero-inner">
          <div className="hero-photo">
            <img src={stef} alt="Stéphane Mbangossoum" />
          </div>

          <div className="hero-content">
            <p className="hero-label">// sysops · cloud · devops</p>
            <h1 className="hero-name">{t("name")}</h1>
            <p className="hero-title">{t("sysops_and_cloud_engineer")}</p>

            <div className="hero-domains">
              {domains.map((d, i) => (
                <div key={i} className="hero-domain-row">
                  <span className="hero-domain-icon">{d.icon}</span>
                  <span className="hero-domain-label">{d.label}</span>
                  <span className="hero-domain-techs">
                    {d.techs.join(" · ")}
                  </span>
                </div>
              ))}
            </div>

            <div className="hero-ctas">
              <Link to="/timeline" className="hero-cta-primary">
                {t("heroCta1")}
              </Link>
              <Link to="/projects" className="hero-cta-secondary">
                {t("heroCta2")}
              </Link>
            </div>

            <div className="hero-social">
              <a href="https://github.com/nadjial" target="_blank" rel="noreferrer">
                <GitHubIcon />
              </a>
              <a
                href="https://www.linkedin.com/in/st%C3%A9phane-mbangossoum-221609198/"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedInIcon />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Main;
